module.exports = __webpack_public_path__ + "static/media/hero_privacy.31ae7f96.png";